export default {
    InternalReturnRefund: {
        OrderNo: '退款单号/销售单号',
        document: '退货物流单号',
        Return: '退货单来源',
        nickname: '买家昵称',
        Returned: '退货人',
        Tripartite: '三方退货时间',
        refund: '新增退货退款单',
        form: {
            Internal: '内部退货单号',
            Third: '三方退货单号',
            party: '客户订单号',
            order: '内部订单号',
            Return: '退货单类型',
            type: '退货类型',
            source: '退货单来源',
            refund: '退货退款原因',
            comments: '买家备注',
            service: '客服备注',
            quantity: '退货数量',
            Total: '应退买家合计',
            method: '结算方式',
            Receiving: '收货仓库',
            logistics: '退货物流信息',
            nickname: '买家昵称',
            Returned: '退货人',
            mobile: '退货人手机号',
            address: '退货人地址',
            store: '销售店铺',
            channel: '销售渠道',
            returntime: '三方退货时间',
            creation: '内部创单时间',
            completion: '退货完成时间',
        },
    }
};
